import EmployeeWelfareComponent from "../components/EmployeeWelfare";
import useEmployeeWelfare from "../hooks/useEmployeeWelfare";

const EmployeeWelfarePage = () => {
    const useEmployeeWelfareProps = useEmployeeWelfare();
    return <EmployeeWelfareComponent {...useEmployeeWelfareProps} />
}

export default EmployeeWelfarePage;